import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.308 2.15h-.65V1.067h-1.083V2.15h-7.15V1.067H3.342V2.15h-.65c-.896 0-1.625.73-1.625 1.625v9.534c0 .896.729 1.625 1.625 1.625h10.616c.896 0 1.625-.73 1.625-1.625V3.775c0-.896-.729-1.625-1.625-1.625m.542 11.159a.54.54 0 0 1-.542.541H2.692a.54.54 0 0 1-.542-.541v-7.15h11.7zm0-8.234H2.15v-1.3c0-.298.243-.541.542-.541h.65v1.083h1.083V3.234h7.15v1.083h1.083V3.234h.65c.299 0 .542.243.542.541z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.333 7.467h-1.6v1.6h1.6zM5.333 10.667h-1.6v1.6h1.6zM8.8 7.467H7.2v1.6h1.6zM8.8 10.667H7.2v1.6h1.6zM12.267 7.467h-1.6v1.6h1.6zM12.267 10.667h-1.6v1.6h1.6z"
    }, null, -1)
  ]))]))
}
export default { render: render }